import {
  TrackTypeEnum,
  getTrackTypeString,
  trackTypeArray,
} from '@/entities/tracks'
import {
  DislikeOutlined,
  FolderAddOutlined,
  LikeOutlined,
  SearchOutlined,
  ShareAltOutlined,
  VerticalLeftOutlined,
} from '@ant-design/icons'
import { Card, Col, Radio, Row, Statistic } from 'antd'
import { type CheckboxGroupProps } from 'antd/es/checkbox'
import { type RadioGroupProps } from 'antd/lib'
import { useUnit } from 'effector-react'

import {
  $isLoadingInitially,
  $totalData,
  $trackType,
  trackTypeChanged,
} from '../../model/statistics-tracks-data.model'
import { TracksStatisticsTable } from '../TracksStatisticsTable'
import styles from './styles.module.scss'

export function TracksStatistics() {
  const loading = useUnit($isLoadingInitially)

  const totalData = useUnit($totalData)
  const trackType = useUnit($trackType)
  const changeTrackType = useUnit(trackTypeChanged)
  const options: CheckboxGroupProps<TrackTypeEnum>['options'] = trackTypeArray
    .filter((type) => type !== TrackTypeEnum.Jingle)
    .map((type) => ({
      label: getTrackTypeString(type),
      value: type,
    }))
  const onChange: RadioGroupProps['onChange'] = (event) => {
    const value = event.target.value
    changeTrackType(value)
  }

  const stats = [
    {
      title: 'Нравится',
      value: totalData?.totalLikesCount,
      icon: <LikeOutlined />,
    },
    {
      title: 'Не нравится',
      value: totalData?.totalDislikesCount,
      icon: <DislikeOutlined />,
    },
    {
      title: 'Поделились',
      value: totalData?.totalSharesCount,
      icon: <ShareAltOutlined />,
    },
    {
      title: 'Добавлено в плейлист',
      value: totalData?.totalPlaylistsCount,
      icon: <FolderAddOutlined />,
    },
    {
      title: 'Прослушивания >50%',
      value: totalData?.totalListensCount50,
    },
    {
      title: 'Прослушивания >75%',
      value: totalData?.totalListensCount75,
    },
    {
      title: 'Прослушивания >95%',
      value: totalData?.totalListensCount95,
    },
    {
      title: 'Всего прослушиваний',
      value: totalData?.totalListensCount,
    },

    {
      title: 'Запусков из поиска',
      value: totalData?.totalSearchesCount,
      icon: <SearchOutlined />,
    },
    {
      title: 'Пропусков',
      value: totalData?.totalSwapsCount,
      icon: <VerticalLeftOutlined />,
    },
  ]

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Radio.Group
          block
          options={options}
          optionType="button"
          value={trackType}
          onChange={onChange}
        />
      </Col>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          {stats.map((item) => (
            <Col xs={24} sm={12} lg={6} key={item.title}>
              <Card variant="borderless" className={styles.statisticsCard}>
                <Statistic
                  loading={loading}
                  title={item.title}
                  value={item.value}
                  prefix={item.icon}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
      <Col span={24}>
        <TracksStatisticsTable />
      </Col>
    </Row>
  )
}
